export function getIndexedDBKey(key, databaseName, objectStoreName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(databaseName);

    request.onupgradeneeded = (event) => {
      const database = event.target.result;
      database.createObjectStore(objectStoreName, { keyPath: 'key' });
      console.warn(
        'IndexedDB Upgrade Needed. Created fresh Database and ObjectStore',
      );
    };

    request.onsuccess = () => {
      const database = request.result;
      const transaction = database.transaction(objectStoreName, 'readonly');
      const configuration = transaction.objectStore(objectStoreName);
      const getKey = configuration.get(key);

      getKey.onsuccess = () => {
        resolve(getKey.result);
      };

      transaction.onerror = () => {
        reject(transaction.error);
      };
    };
  });
}
